import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../../utils/auth';
import { Container, Card, Button, Table, Row, Col, Spinner } from 'react-bootstrap';

const BoardDetail = () => {
  const [board, setBoard] = useState({});
  const { boardId } = useParams();
  const { authInfo } = useAuth();
  const navigate = useNavigate();
  const [loading,setLoading] = useState(true);

  const deleteBoardContent = async () =>{
    console.log('authInfo',authInfo);

    if(!window.confirm('정말 삭제하시겠습니까?')) return;

    console.log('받아오는건?'+boardId);
    try {
      const response = await axios.delete('/board/deleteBoardContent',{
        headers: {
          // 'X-CSRF-TOKEN': csrfToken
          Authorization: `Bearer ${authInfo.token}`,
      },
        params : {
          boardId,
          userId: authInfo.user.memberId  // 🚀 userId만 params로 전송
        }
      });

      console.log('삭제완료',response);
      // alert('삭제완료');
      if(response.status === 200){
        if(response.data === '작성자가 아닙니다.'){
          alert('작성자가 아닙니다.');
        }else{
          alert('삭제완료');
        }
      }
        navigate('/board');
    } catch (error) {
      console.error('삭제실패',error);
    }
    
  }


  useEffect(() => {

    try {
      // authInfo가 null일 때는 아무 것도 하지 않음
    if (authInfo === null) {
      return;
    }

    // 로그인 상태 확인 후 로그인되지 않았으면 로그인 페이지로 이동
    if (!authInfo.token) {
      alert('로그인 후 이용하세요.');
      navigate('/signIn');
      return;
    }

    // 서버에서 데이터 가져오기
    axios.get(`/board/boardDetail?boardId=${boardId}`, {
      headers: {
        Authorization: `Bearer ${authInfo.token}`
      }
    })
      .then(response => {
        console.log(response.data);
        // 데이터를 state에 설정
        setBoard(response.data);
      })
      .catch(error => {
        console.error('Error fetching board detail:', error);
        if (error.response && error.response.status === 403) {
          alert('접근 권한이 없습니다. 로그인 후 이용하세요.');
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          window.location.reload();
          navigate('/signIn');
        }
      });
    } catch (error) {
      console.log(error);
    }finally {
      setLoading(false);
    }
  }, [boardId, authInfo, navigate]);

  if (authInfo === null) {
    // authInfo가 설정될 때까지 로딩 상태를 표시하거나 null을 반환
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  }

  if(loading){
      return(
        <div style={{textAlign:'center',marginTop:'50px'}} >
          {/* 로딩중입니다. 문구 */}
          <Spinner animation="border" variant="primary" />
        </div>
      )
    }

  const formatDate = (dateArray) => {
    if (!Array.isArray(dateArray) || dateArray.length < 6) return "날짜 없음";
  
    const [year, month, day, hour, minute] = dateArray;
  
    // `Date` 객체 생성 (월은 0부터 시작하므로 `month - 1`)
    const dateObj = new Date(year, month - 1, day, hour, minute);
  
    if (isNaN(dateObj.getTime())) {
      return "올바르지 않은 날짜";
    }
  
    // 날짜 포맷 적용
    const formattedDate = dateObj.toLocaleString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true, // AM/PM 표시
    });
  
    // "MM/DD/YYYY, hh:mm AM" 형식 → "YYYY/MM/DD hh:mmAM"으로 변환
    const [monthPart, dayPart, yearPart] = formattedDate.split(",")[0].split("/");
    const timePart = formattedDate.split(", ")[1];
  
    return `${yearPart}/${monthPart}/${dayPart} ${timePart}`;
  };

  return (
    <Container className="mt-4">
      <Card className="shadow-sm p-4">
        <Card.Body>
          <Card.Title className="text-primary">제목 : {board.title}</Card.Title>
          <Table bordered>
            <tbody>
              <tr>
                <th style={{ width: "20%" }}>작성자</th>
                <td>{board.nickname}</td>
              </tr>
              <tr>
                <th>등록일</th>
                <td>{formatDate(board.regdate)}</td>
              </tr>
              <tr>
                <th>내용</th>
                <td style={{ whiteSpace: 'pre-line' }}>{board.content}</td>
              </tr>
            </tbody>
          </Table>
        </Card.Body>
      </Card>

      <Row className="mt-3">
        <div style={{display:'flex',justifyContent:'space-between'}}>
          <Button variant="secondary" onClick={() => navigate('/board')} block>
            뒤로 가기
          </Button>
          <Button variant="danger" onClick={deleteBoardContent} block>
            삭제
          </Button>
        </div>
      </Row>
    </Container>
  );

};

export default BoardDetail;
